// removed by extract-text-webpack-plugin
module.exports = {"title":"title___3gB_A","intervalGroup":"intervalGroup___1em-l"};